import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationUA from './locales/ua.json';
import translationEN from './locales/en.json';
import translationIT from './locales/it.json';

const resources = {
  ua: {
    translation: translationUA
  },
  en: {
    translation: translationEN
  },
  it: {
    translation: translationIT
  }
};

const initialLanguage = localStorage.getItem('language') || 'ua';

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage,
    fallbackLng: 'ua',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
